export function initSlickSlider(selector, options) {
  const container = document.querySelectorAll(selector);

  const start = () => container?.classList?.add("grabbing");
  const stop = () => container?.classList?.remove("grabbing");

  document.addEventListener("mousedown", start);
  document.addEventListener("touchstart", start);

  document.addEventListener("mouseup", stop);
  document.addEventListener("touchend", stop);

  $(container).slick(options);
}

export function initFeaturesContentLinks() {
  const titles = document.querySelectorAll(".slider-features:not(.rebranding-container) .titles h2");
  const content = document.querySelectorAll(".slider-features:not(.rebranding-container) .content");
  const contents = document.querySelector(".slider-features:not(.rebranding-container) .contents");

  function updateContentsHeight() {
    const contentElements = document.querySelectorAll(".content:not(.rebranding-content)");
    let maxHeight = 0;
    let maxWidth = 0;

    contentElements.forEach(function (content) {
      if (content.offsetHeight > maxHeight) {
        maxHeight = content.offsetHeight;
      }
      if (content.offsetWidth > maxWidth) {
        maxWidth = content.offsetWidth;
      }
    });

    contents.style.height = maxHeight + "px";
    contents.style.width = maxWidth + "px";
  }

  updateContentsHeight();
  window.addEventListener("resize", updateContentsHeight);

  titles.forEach((title, index) => {
    title.addEventListener("click", () => {
      titles.forEach((title) => {
        title.classList.remove("active");
      });

      content.forEach((content) => {
        content.classList.remove("active");
      });

      content[index].classList.add("active");
      titles[index].classList.add("active");
    });
  });
}
